

<form [formGroup]="additionalSecurityForm" >
    <fieldset class="form-group" [ngClass]="{'is-invalid': additionalSecurityForm.get('tad_additional_security_property_category').touched &&
    additionalSecurityForm.get('tad_additional_security_property_category').errors?.required}">
    <div class="row">
      <div class="col-12 col-md-6">
        <legend>What’s the purpose of the property?</legend>
        <div class="c-radio--list custom-controls-stacked">
          <span class="c-radio-button">
            <label class="custom-control custom-radio">
              <input id="tad_additional_security_property_category" value="0" (ngModelChange)="reset(tad_additional_security_property_category.value)" [checked]="tad_additional_security_property_category.value == 0" formControlName="tad_additional_security_property_category" name="tad_additional_security_property_category" type="radio" class="custom-control-input">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Residential</span>
            </label>
          </span>
          <span class="c-radio-button">
            <label class="custom-control custom-radio">
              <input id="tad_additional_security_property_category" value="2" (ngModelChange)="reset(tad_additional_security_property_category.value)" [checked]="tad_additional_security_property_category.value == 2"  formControlName="tad_additional_security_property_category" name="tad_additional_security_property_category" type="radio" class="custom-control-input">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Commercial and Semi-Commercial</span>
            </label>
          </span>
          <span class="c-radio-button">
            <label class="custom-control custom-radio">
              <input id="tad_additional_security_property_category" value="3" (ngModelChange)="reset(tad_additional_security_property_category.value)" [checked]="tad_additional_security_property_category.value == 3" formControlName="tad_additional_security_property_category" name="tad_additional_security_property_category" type="radio" class="custom-control-input">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Land</span>
            </label>
          </span>
        </div>
        @if (additionalSecurityForm.get('tad_additional_security_property_category').touched &&
          additionalSecurityForm.get('tad_additional_security_property_category').errors?.required) {
          <div class="d-flex invalid-feedback">
            We need to know the type of property you have.
          </div>
        }
      </div>
    </div>
  </fieldset>
    <fieldset [ngClass]="{'is-invalid': additionalSecurityForm.get('tad_additional_security_property_type').touched && 
    additionalSecurityForm.get('tad_additional_security_property_type').errors?.required}">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group" class="visually-hidden">
          <label for="tad_additional_security_property_type">What type of property is it?</label>
          <select class="form-control" id="tad_additional_security_property_type">
            <option value="">Please select</option>
          </select>
        </div>
        @if (tad_additional_security_property_category.value !== null && tad_additional_security_property_category.value == '2') {
          <div class="form-group">
            <label for="tad_additional_security_property_type">What type of property is it?</label>
            <select formControlName="tad_additional_security_property_type" class="form-control" id="tad_additional_security_property_type">
              <option value="null">Please select</option>
              <option value="41">Petrol Station</option>
              <option value="49">Development Site</option>
              <option value="50">Multifamily House</option>
              <option value="52">Development Site- Residential</option>
              <option value="53">Shops</option>
              <option value="54">Financial and Professional Services</option>
              <option value="55">Restaurants and cafes</option>
              <option value="56">Drinking establishments</option>
              <option value="57">Hot food takeaways</option>
              <option value="59">General Industrial</option>
              <option value="60">Storage or distribution</option>
              <option value="61">Hotels and hostels</option>
              <option value="62">Residential institutions</option>
              <option value="63">Secure Residential Institution</option>
              <option value="64">Non-residential institutions</option>
              <option value="65">Assembly and leisure</option>
              <option value="66">Development Site- Semi-commercial</option>
              <option value="67">Partially Commercial Use</option>
              <option value="68">Caravan Park</option>
              <option value="69">Car Park</option>
              <option value="70">Nightclubs</option>
              <option value="71">Office/ business premises</option>
            </select>
                    <together-auction-dip-validate-fields [displayError]="(additionalSecurityForm.get('tad_additional_security_property_type').touched && 
                        additionalSecurityForm.get('tad_additional_security_property_type').errors?.required)" errorMsg="We need to know the type of property you have."></together-auction-dip-validate-fields>
          </div>
        }
        @if (tad_additional_security_property_category.value !== null && tad_additional_security_property_category.value === '0') {
          <div class="form-group">
            <label for="tad_additional_security_property_type">What type of property is it?</label>
            <select formControlName="tad_additional_security_property_type" class="form-control" id="tad_additional_security_property_type">
              <option value="null">Please select</option>
              <option value="5">House - End terrace</option>
              <option value="6">House - Mid terrace</option>
              <option value="7">House - Semi Detached</option>
              <option value="8">House - Detached</option>
              <option value="9">Bungalow - Semi-Detached</option>
              <option value="10">Bungalow - Detached</option>
              <option value="11">Flat/Maisonette - converted</option>
              <option value="12">Flat/Maisonette - purpose built</option>
              <option value="17">Bungalow - End terrace</option>
              <option value="18">Bungalow - Mid Terrace</option>
              <option value="51">House in Multiple Occupation</option>
            </select>
                    <together-auction-dip-validate-fields [displayError]="(additionalSecurityForm.get('tad_additional_security_property_type').touched && 
                additionalSecurityForm.get('tad_additional_security_property_type').errors?.required)" errorMsg="We need to know the type of property you have."></together-auction-dip-validate-fields>
          </div>
        }
        <div class="form-group" class="visually-hidden">
          <label for="tad_additional_security_property_type">What type of property is it?</label>
          <select formControlName="tad_additional_security_property_type" class="form-control" id="tad_additional_security_property_type">
            <option value="37">Land</option>
          </select>
        </div>

      </div>
    </div>
  </fieldset>
  <fieldset>
    <div class="row">
      <div class="col-12 col-md-6">
        <label>Address</label>
        <app-address [incomingAddress]="address" [addressLookUp]="additionalSecurityForm.controls.addresslookup" (outgoingAddress)="_handleIncomingAddress($event)" (form_out)="_handleIncomingForm($event)"></app-address>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group c-input--pound" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_property_value')">
          <label for="examplePound">What's the value of the property?</label>
          <div class="input-group" [ngClass]="{'is-invalid': additionalSecurityForm.get('tad_additional_security_property_value').invalid && (additionalSecurityForm.get('tad_additional_security_property_value').dirty && additionalSecurityForm.get('tad_additional_security_property_value').touched),'is-valid':additionalSecurityForm.get('tad_additional_security_property_value').valid && additionalSecurityForm.get('tad_additional_security_property_value').dirty}">
            <span class="input-group-addon" id="pound-addon">&pound;</span>
            <input type="number" [ngClass]="setDynamicClasses('tad_additional_security_property_value')" name="tad_additional_security_property_value" formControlName="tad_additional_security_property_value" class="form-control" aria-describedby="pound-addon" id="examplePound">
          </div>
        </div>
                <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_property_value').touched && 
                    additionalSecurityForm.get('tad_additional_security_property_value').errors?.required" errorMsg="We need to know the value of the property."></together-auction-dip-validate-fields>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group c-input--pound" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_purchase_price')">
          <label for="examplePound">What did you originally pay for it?</label>
          <div class="input-group" [ngClass]="{'is-invalid': additionalSecurityForm.get('tad_additional_security_purchase_price').invalid && (additionalSecurityForm.get('tad_additional_security_property_value').dirty && additionalSecurityForm.get('tad_additional_security_property_value').touched),'is-valid':additionalSecurityForm.get('tad_additional_security_property_value').valid && additionalSecurityForm.get('tad_additional_security_property_value').dirty}">
            <span class="input-group-addon" id="pound-addon">&pound;</span>
            <input type="number" [ngClass]="setDynamicClasses('tad_additional_security_purchase_price')" name="tad_additional_security_purchase_price" formControlName="tad_additional_security_purchase_price" class="form-control" aria-describedby="pound-addon" id="examplePound">
          </div>
                    <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_purchase_price').touched && 
                    additionalSecurityForm.get('tad_additional_security_purchase_price').errors?.required" errorMsg="We need to know how much you paid for the property."></together-auction-dip-validate-fields>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_purchase_date_month')">
    <div class="row">
      <div class="col-12 col-md-6">
        <legend>Purchase date</legend>
        <div class="d-flex">
          <div class="w-40 mr-1">
            <label for="tad_additional_security_purchase_date_month" class="visually-hidden">Month (MM)</label>
            <input [ngClass]="setDynamicClasses('tad_additional_security_purchase_date_month')" formControlName="tad_additional_security_purchase_date_month" type="number" class="form-control" id="tad_additional_security_purchase_date_month " placeholder="MM" min="1"
              max="12">
            </div>
            <div class="w-40">
              <label for="tad_additional_security_purchase_date_year" class="visually-hidden">Year (YYYY)</label>
              <input [ngClass]="setDynamicClasses('tad_additional_security_purchase_date_year')" formControlName="tad_additional_security_purchase_date_year" type="number" class="form-control" id="tad_additional_security_purchase_date_year" placeholder="YYYY" min="2017"
                max="2020">
              </div>
            </div>
            @if (additionalSecurityForm.hasError('dateValueInvalid')) {
              <div class="d-flex invalid-feedback">
                Please enter a valid puchase date.
              </div>
            }
            @if (additionalSecurityForm.hasError('olderThanGregorian')) {
              <div class="d-flex invalid-feedback">
                The purchase date for the property you have provided is too far in the past for us to be able to add to the loan as a security.
              </div>
            }
            @if (additionalSecurityForm.hasError('tooFarInFuture')) {
              <div class="d-flex invalid-feedback">
                We cannot add additional securities which are being purchased in the future
              </div>
            }
                <together-auction-dip-validate-fields [displayError]="(additionalSecurityForm.get('tad_additional_security_purchase_date_year').touched && 
                    additionalSecurityForm.get('tad_additional_security_purchase_date_year').errors?.required) ||
                    (additionalSecurityForm.get('tad_additional_security_purchase_date_month').touched && 
                    additionalSecurityForm.get('tad_additional_security_purchase_date_month').errors?.required)" errorMsg="We need to know the date you purchased this property."></together-auction-dip-validate-fields>

          </div>
        </div>
      </fieldset>
      <fieldset class="form-group">
        <div class="row">
          <div class="col-12 col-md-6">
            <legend>Do you have an existing mortgage on the property?</legend>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="d-flex">
              <div class="w-40 mr-1">
                <div class="c-radio--separated">
                  <span class="c-radio-button">
                    <input type="radio" formControlName="tad_additional_security_secured" [checked]="tad_additional_security_secured.value == 'true'" id="tad_as_yes" name="tad_additional_security_secured" value="true">
                    <label class="c-radio-button__label" for="tad_as_yes">
                      <span class="c-radio-button__faux">Yes</span>
                      <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                    </label>
                  </span>
                </div>
              </div>
              <div class="w-40">
                <div class="c-radio--separated">
                  <span class="c-radio-button">
                    <input type="radio" formControlName="tad_additional_security_secured" [checked]="tad_additional_security_secured.value == 'false'" id="tad_as_no" name="tad_additional_security_secured" value="false">
                    <label class="c-radio-button__label" for="tad_as_no">
                      <span class="c-radio-button__faux">No</span>
                      <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                    </label>
                  </span>
                </div>
              </div>
            </div>
                <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured').touched &&
                additionalSecurityForm.get('tad_additional_security_secured').errors?.required" errorMsg="We need to know if you have an existing mortgage on this property."></together-auction-dip-validate-fields>
          </div>
        </div>

      </fieldset>
      @if (tad_additional_security_secured.value == 'true') {
        <div>
          <fieldset class="form-group mb-0">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group c-input--pound" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_secured_outstanding_mortgage_balance')">
                  <label for="examplePound">How much is outstanding on your mortgage?</label>
                  <div class="input-group">
                    <span class="input-group-addon" id="pound-addon">&pound;</span>
                    <input type="number" [ngClass]="setDynamicClasses('tad_additional_security_secured_outstanding_mortgage_balance')" formControlName="tad_additional_security_secured_outstanding_mortgage_balance" name="tad_additional_security_property_value" class="form-control"
                      aria-describedby="pound-addon" id="tad_additional_security_secured_outstanding_mortgage_balance">
                    </div>
                        <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_balance').touched
                                && additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_balance').errors?.required" errorMsg="We need to know how much is outstanding on your mortgage."></together-auction-dip-validate-fields>
                        <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_balance').touched && 
                                additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_balance').errors?.min" errorMsg="Please enter the full balance remaining on your first charge. If there is no balance remaining, please enter 0."></together-auction-dip-validate-fields>
                  </div>
                  <div class="form-group" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_secured_outstanding_mortgage_lender')">
                    <label for="tad_additional_security_secured_outstanding_mortgage_lender">Which company is your mortgage with?</label>
                    <input type="email" [ngClass]="setDynamicClasses('tad_additional_security_secured_outstanding_mortgage_lender')" formControlName="tad_additional_security_secured_outstanding_mortgage_lender" class="form-control" id="tad_additional_security_secured_outstanding_mortgage_lender"
                      aria-describedby="emailHelp">
                        <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_lender').touched && 
                            additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_lender').errors?.required" errorMsg="We need to know which company this mortgage is with."></together-auction-dip-validate-fields>
                        <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_lender').touched &&
                            additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_lender').errors?.minlength" errorMsg="Please enter the full name of the lender which you got your first charge with."></together-auction-dip-validate-fields>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset class="form-group">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <legend>Do you have additional loans secured against this property?</legend>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="d-flex">
                      <div class="w-40 mr-1 ">
                        <div class="c-radio--separated">
                          <span class="c-radio-button">
                            <input type="radio" formControlName="tad_additional_security_secured_outstanding_mortgage_other_loans_secured" [checked]="tad_additional_security_secured_outstanding_mortgage_other_loans_secured.value == 'true'" name="tad_additional_security_secured_outstanding_mortgage_other_loans_secured" id="tad_all_yes" value="true" >
                            <label class="c-radio-button__label" for="tad_all_yes">
                              <span class="c-radio-button__faux">Yes</span>
                              <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                            </label>
                          </span>
                        </div>
                      </div>
                      <div class="w-40">
                        <div class="c-radio--separated">
                          <span class="c-radio-button">
                            <input formControlName="tad_additional_security_secured_outstanding_mortgage_other_loans_secured" [checked]="tad_additional_security_secured_outstanding_mortgage_other_loans_secured.value == 'false'" value="false" type="radio" name="tad_additional_security_secured_outstanding_mortgage_other_loans_secured" id="tad_all_no" >
                            <label class="c-radio-button__label" for="tad_all_no">
                              <span class="c-radio-button__faux">No</span>
                              <svg class="c-radio-button__faux-indicator icon-tick" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 13"><path fill="#f9b114" d="M5.57 7.53L2.78 4.79 0 7.53l2.78 2.73L5.57 13l2.78-2.74L16 2.74 13.22 0 5.57 7.53z" /></svg>
                            </label>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_other_loans_secured').touched &&
                            additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_other_loans_secured').errors?.required" errorMsg="We need to know if you have any additional loans secured against this property."></together-auction-dip-validate-fields>
              </fieldset>
              <div class="row">
                <div class="col-12 col-md-6">
                  @if (tad_additional_security_secured_outstanding_mortgage_other_loans_secured.value == 'true') {
                    <div class="form-group c-input--pound" [ngClass]="setDynamicClassesForFormgroup('tad_additional_security_secured_outstanding_mortgage_loan_balance')">
                      <label for="examplePound">How much is outstanding on these additional loans?</label>
                      <div class="input-group">
                        <span class="input-group-addon" id="pound-addon">&pound;</span>
                        <input type="number" [ngClass]="setDynamicClasses('tad_additional_security_secured_outstanding_mortgage_loan_balance')" formControlName="tad_additional_security_secured_outstanding_mortgage_loan_balance" name="tad_additional_security_secured_outstanding_mortgage_loan_balance"
                          class="form-control" aria-describedby="pound-addon" id="tad_additional_security_secured_outstanding_mortgage_loan_balance">
                        </div>
                    <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_loan_balance').touched && 
                            additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_loan_balance').errors?.required" errorMsg="We need to know how much is outstanding on these additional loans."></together-auction-dip-validate-fields>
                    <together-auction-dip-validate-fields [displayError]="additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_loan_balance').invalid && additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_loan_balance').errors.min &&
                                    additionalSecurityForm.get('tad_additional_security_secured_outstanding_mortgage_loan_balance').touched" errorMsg="Please enter the full balance remaining on your first charge. If there is no balance remaining, please enter 0."></together-auction-dip-validate-fields>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

            <!-- <pre><code>{{security.existingChargeDetailRequest | json}}</code></pre> -->
          </form>
